import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-width: 100%;
  overflow: hidden;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
`;

export const SelectTabWrapper = styled.div`
  width: calc(100% - 30px);
  margin: 0 15px;
  height: 35px;
  border: 1px solid #78818e;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedTab = styled.div`
  flex: 1;
  height: 100%;
  background: #fff;
  color: #373f4c;
  font-size: 13px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.isSelected &&
    css`
      background: #78818e;
      color: #fff;
      font-weight: bold;
    `};
`;

export const SelectedTabText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  margin-top: 15px;
  border: 1px solid #f2f2f2;
  & > tbody th {
    height: 36px;
    font-size: 11px;
    text-align: center;
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
  }

  & > tbody > tr > td {
    height: 67px;
    text-align: center;
  }
  & > tbody tr {
    border-top: 1px solid #f2f2f2;
  }

  & > tbody > tr > td:nth-child(1) {
    text-align: right;
    padding-left: 15px;
  }
  & > tbody > tr > td:nth-child(2) {
    text-align: center;
  }
  & > tbody > tr > td:nth-child(3) {
    text-align: left;
    padding-right: 15px;
  }
`;

export const TeamWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const TeamName = styled.span`
  display: inline-block;
  min-width: 82px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 7px;
  vertical-align: middle;
  ${(props) =>
    props.isSelected &&
    css`
      font-weight: bold;
    `};
`;

export const TeamLogo = styled.div`
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;

  min-width: 33px;
  max-width: 33px;
  & > img {
    height: 33px;
    max-width: 100%;
  }
`;
